import React from "react";
import { NavLink } from "react-router-dom";
import IndustryLeaders from "../../components/industry-leaders/industry-leaders";
import Testimonials from "../../components/home/Testimonials";
import SalesBanner from "../../assets/images/sales-prof/sp-banner.png";
import TargetLeadGen from "../../assets/images/sales-prof/target_lead_gen.png";
import TimeSavingAuto from "../../assets/images/sales-prof/time-saving.png";
import SeamlessCRMinte from "../../assets/images/sales-prof/seamlessCrmInte.png";
import comprehensiveLeadProfiles from "../../assets/images/sales-prof/comprehensiveLeadProfs.png";
import ImprovedFollowEffi from "../../assets/images/sales-prof/ImprovedFollowUpEffi.png";
import RealTimeAnalytics from "../../assets/images/sales-prof/realTimeAna.png";
import CollabMadeEasy from "../../assets/images/sales-prof/CollabMadeEasy.png";
import IncreaseProductivity from "../../assets/images/sales-prof/inc-prod.svg";
import BetterLeadQuality from "../../assets/images/sales-prof/betterLeadQua.svg";
import ShortenSalesCycle from "../../assets/images/sales-prof/shortenSalesCycle.svg";
import GreaterSalesInsights from "../../assets/images/sales-prof/greaterSalesInsights.svg";
import Cta from "../../components/cta/cta";

const SalesPage = () => {
  return (
    <>
      <div className="sales-main-wrapper">
        <section className="sa-banner">
          <div className="max-container">
            <div className="padd-90">
              <div className="grid-auto-fit align-items-center max-width950">
                <div>
                  <h1 className="heading39px roboto-bold mb20 text-color-131415">
                    The Ultimate Tool <br /> for Sales Professionals
                  </h1>
                  <p className="heading16px roboto-regular mb30">
                    Sales professionals can leverageBeyond Leadz data services
                    to generate more leads by accessing targeted contact
                    information of potential customers in their desired industry
                    or market segment.
                  </p>

                  <ul className="btn-sec">
                    <li>
                      <NavLink
                        to={"/signup"}
                        className="common-btn-class main-btn-primary roboto-regular"
                      >
                        {" "}
                        Subscribe Now
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to={"/contact-us"}
                        className="common-btn-class transparentBtn roboto-regular"
                      >
                        Contact us
                      </NavLink>
                    </li>
                  </ul>
                </div>
                <div>
                  <img
                    src={SalesBanner}
                    className="img-responsive"
                    alt="The Ultimate Tool for Sales Professionals"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <IndustryLeaders />

        <section className="">
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold mb10 heading29px mb60 text-center">
                Why Sales Professionals Should Use BeyondLeadz
              </h2>
              <div className="grid-auto-fit align-items-center mb60 max-width950">
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Targeted Lead Generation
                  </h3>
                  <p className="heading16px roboto-regular">
                    BeyondLeadz helps you identify and capture high-quality
                    leads that match your ideal customer profile. With advanced
                    segmentation and filtering options, you can focus your
                    efforts on prospects that are most likely to convert.
                  </p>
                </div>
                <div>
                  <img
                    src={TargetLeadGen}
                    alt="Targeted Lead Generation"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
              </div>

              <div className="grid-auto-fit align-items-center mb60 max-width950">
                <div className="block-order2">
                  <img
                    src={TimeSavingAuto}
                    alt="Time-Saving Automation"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Time-Saving Automation
                  </h3>
                  <p className="heading16px roboto-regular">
                    Automate routine tasks like lead capturing, data entry,
                    follow-ups, and scheduling, freeing up more time for
                    meaningful interactions with your prospects.
                  </p>
                </div>
              </div>

              <div className="grid-auto-fit align-items-center mb60 max-width950">
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Seamless CRM Integration
                  </h3>
                  <p className="heading16px roboto-regular">
                    BeyondLeadz integrates effortlessly with your existing CRM,
                    ensuring that your lead data is always up-to-date and
                    accessible. No more switching between multiple
                    platforms—everything you need is in one place.
                  </p>
                </div>
                <div>
                  <img
                    src={SeamlessCRMinte}
                    alt="Seamless CRM Integration"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
              </div>

              <div className="grid-auto-fit align-items-center mb60 max-width950">
                <div className="block-order2">
                  <img
                    src={comprehensiveLeadProfiles}
                    alt="Comprehensive Lead Profiles"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Comprehensive Lead Profiles
                  </h3>
                  <p className="heading16px roboto-regular">
                    Gain deeper insights into your leads with enriched data,
                    including detailed contact information, company details, and
                    behavioural analytics. This allows you to tailor your
                    approach and create personalised pitches that resonate.
                  </p>
                </div>
              </div>

              <div className="grid-auto-fit align-items-center mb60 max-width950">
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Improved Follow-Up Efficiency
                  </h3>
                  <p className="heading16px roboto-regular">
                    Set reminders, automate follow-up sequences, and track
                    engagement to ensure no lead falls through the cracks. With
                    Leadz, you can nurture your leads effectively, turning
                    interest into sales.
                  </p>
                </div>
                <div>
                  <img
                    src={ImprovedFollowEffi}
                    alt="Improved Follow-Up Efficiency"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
              </div>

              <div className="grid-auto-fit align-items-center mb60 max-width950">
                <div className="block-order2">
                  <img
                    src={RealTimeAnalytics}
                    alt="Real-Time Analytics"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Real-Time Analytics
                  </h3>
                  <p className="heading16px roboto-regular">
                    Monitor your sales performance with real-time analytics and
                    reporting. Track key metrics like conversion rates, lead
                    sources, and sales pipeline progress to make data-driven
                    decisions and refine your strategy.
                  </p>
                </div>
              </div>

              <div className="grid-auto-fit align-items-center max-width950">
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Collaboration Made Easy
                  </h3>
                  <p className="heading16px roboto-regular">
                    Share leads, notes, and insights with your team in real
                    time, ensuring everyone is on the same page. Collaboration
                    has never been easier, enabling a more cohesive and
                    effective sales approach.
                  </p>
                </div>
                <div>
                  <img
                    src={CollabMadeEasy}
                    alt="Collaboration Made Easy"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="benefits-for-sales"
          style={{ backgroundColor: "#F8F8F8" }}
        >
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold mb40 heading29px text-center">
                Benefits for Sales Professionals
              </h2>

              <div
                className="grid-auto-fit max-width950"
                style={{
                  "--grid-columns": "repeat(2, 1fr)",
                  "--grid-gap": "24px",
                }}
              >
                <div className="common-white-box common-shadow">
                  <img
                    src={IncreaseProductivity}
                    className="img-responsive position-relative"
                    alt="Increased Productivity"
                    loading="lazy"
                  />

                  <h3 className="roboto-bold heading20px mb10 mt20">
                    Increased Productivity
                  </h3>
                  <p className="roboto-regular heading16px">
                    Automate tedious tasks, reduce manual data entry, and focus
                    on high-value activities that drive sales.
                  </p>
                </div>

                <div className="common-white-box common-shadow">
                  <img
                    src={BetterLeadQuality}
                    className="img-responsive position-relative"
                    alt="Better Lead Quality"
                    loading="lazy"
                  />

                  <h3 className="roboto-bold heading20px mb10 mt20">
                    Better Lead Quality
                  </h3>
                  <p className="roboto-regular heading16px">
                    Access enriched and accurate lead data, allowing you to
                    prioritize and pursue the most promising opportunities.
                  </p>
                </div>

                <div className="common-white-box common-shadow">
                  <img
                    src={ShortenSalesCycle}
                    className="img-responsive position-relative"
                    alt="Shorter Sales Cycles"
                    loading="lazy"
                  />

                  <h3 className="roboto-bold heading20px mb10 mt20">
                    Shorter Sales Cycles
                  </h3>
                  <p className="roboto-regular heading16px">
                    Streamline your sales process with efficient tools and
                    workflows, helping you close deals faster.
                  </p>
                </div>

                <div className="common-white-box common-shadow">
                  <img
                    src={GreaterSalesInsights}
                    className="img-responsive position-relative"
                    alt="Greater Sales Insights"
                    loading="lazy"
                  />

                  <h3 className="roboto-bold heading20px mb10 mt20">
                    Greater Sales Insights
                  </h3>
                  <p className="roboto-regular heading16px">
                    Use real-time data to track your progress, identify
                    bottlenecks, and optimize your sales strategy for better
                    results.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Cta
          heading="Reach Your Ideal Customer With Us"
          firstCta="/signup"
          firstCtaText="Subscribe Now"
          secondCta="/contact-us"
          secondCtaText="Contact us"
        />

        <Testimonials />
      </div>
    </>
  );
};

export default SalesPage;
